// Questions.types.ts

interface MultiLangString {
  en: string;
  "zh-hk": string;
}

type LocalizedOrPlainString = MultiLangString | string;

function getLocalizedString(value: LocalizedOrPlainString, lang: "en" | "zh-hk" = "en"): string {
  if (typeof value === "string") {
    return value;
  }
  return value[lang];
}

interface MultipleChoiceQuestionOption {
  A: LocalizedOrPlainString;
  B: LocalizedOrPlainString;
  C: LocalizedOrPlainString;
  D: LocalizedOrPlainString;
}

interface MultipleChoiceQuestion {
  id: string;
  question: LocalizedOrPlainString;
  option: MultipleChoiceQuestionOption;
  correctOption: "A" | "B" | "C" | "D" | string; // Allows generic strings from data sources
  source: string;
  explanation: LocalizedOrPlainString;
  page: number;
}

export interface QuizPartial {
  id: string;
  // title: LocalizedOrPlainString;
  name: LocalizedOrPlainString;
  paper: LocalizedOrPlainString;
  sections: number[];
  description?: LocalizedOrPlainString;
  totalQuestions: number;
}

export interface SelectionMatrix {
  option: string;
  timeConsumed: number;
  updatedTimes: number;
}
interface QuestionAnswer extends MultipleChoiceQuestion {
  id: string;
  question: LocalizedOrPlainString;
  questionText: LocalizedOrPlainString;
  correctOption: string;
  page: number;
  source: string;
  explanation: LocalizedOrPlainString;
  selected: {
    option: "A" | "B" | "C" | "D" | string | null;
    optionText: LocalizedOrPlainString | null;
  };
  selectionMatrices: SelectionMatrix[];
  timeConsumed: number;
  updatedTimes: number;
  isCorrect: boolean;
}
interface QuizSubmissionResponse {
  submissionId: string;
  userId: string;
  totalTimeConsumed: number;
  isCompleted: boolean;
  attemptNumber: number;
  createdAt: string; // ISO Date String
  updatedAt: string; // ISO Date String
  quiz: QuizPartial;
  responses: QuestionAnswer[];
}

export type {
  LocalizedOrPlainString,
  MultiLangString as LanguageString,
  MultipleChoiceQuestionOption,
  MultipleChoiceQuestion,
  QuizPartial as Quiz,
  QuestionAnswer,
  QuizSubmissionResponse,
};

export { getLocalizedString };
